jQuery(document).ready(function ($) {
	$('#filter-by-month').click(function () {
		$('.wpt_listing_filter_pagination.month').toggleClass('show');
	});

	$('#filter-by-type').click(function () {
		$('.wpt_listing_filter_pagination.category').toggleClass('show');
	});

});
